import React, { useEffect, useState } from "react";

const testimonials = [
  {
    id: 1,
    text: "Lotus Cab made my airport transfer stress-free and on time. Highly professional drivers!",
    name: "Mr. Arjun Sharma",
    role: "Business Owner",
    image: "assets/images/testimonials/testimonial-3-1.jpg",
  },
  {
    id: 2,
    text: "Booking a ride with Lotus Cab is so easy! The car was clean, and the driver was courteous.",
    name: "Miss. Priya Verma",
    role: "Software Engineer",
    image: "assets/images/testimonials/testimonial-3-2.jpg",
  },
  {
    id: 3,
    text: "I trust Lotus Cab for my daily commute. Always punctual and comfortable rides every time.",
    name: "Mr. Rohan Mehta",
    role: "Entrepreneur",
    image: "assets/images/testimonials/testimonial-3-3.jpg",
  },
  {
    id: 4,
    text: "I love Lotus Cab’s friendly service and easy booking process. Makes traveling in the city hassle-free.",
    name: "Miss. Ananya Reddy",
    role: "Student",
    image: "assets/images/testimonials/testimonial-3-4.jpg",
  },
  {
    id: 5,
    text: "Excellent service! The driver arrived early and the ride was smooth throughout. Highly recommended.",
    name: "Mr. Vikram Singh",
    role: "Marketing Manager",
    image: "assets/images/testimonials/testimonial-3-5.jpg",
  },
  {
    id: 6,
    text: "Very reliable cab service. I always use Lotus Cab for late-night travel and feel completely safe.",
    name: "Miss. Neha Kapoor",
    role: "Fashion Designer",
    image: "assets/images/testimonials/testimonial-3-6.jpg",
  },
  {
    id: 7,
    text: "Affordable pricing and great customer support. Booking and tracking the ride was super convenient.",
    name: "Mr. Karan Malhotra",
    role: "Freelancer",
    image: "assets/images/testimonials/testimonial-3-7.jpg",
  },
];

const TestimonialsThree = () => {
  const [current, setCurrent] = useState(0);

  // AUTO SLIDE
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials-three section-space-top">
      <div className="container">
        <div className="testimonials-three__top">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="sec-title">
                <div className="sec-title__top">
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">Our Testimonials</h6>
                </div>
                <h3 className="sec-title__title">
                  People Talk About <br /> Lotus Cab Service
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="row gutter-y-30">
          {testimonials.map((item, index) => (
            <div
              key={item.id}
              className={`col-lg-4 col-md-6 ${
                index === current ? "d-block" : "d-none"
              }`}
            >
              <div className="testimonial-card-three">
                <div className="testimonial-card-three__inner">
                  <div className="testimonial-card-three__top">
                    <div className="testimonial-card-three__icon">
                      <i className="icon-quote-2"></i>
                    </div>

                    <div className="lotus-ratings">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="lotus-ratings__icon">
                          <i className="icon-star"></i>
                        </span>
                      ))}
                    </div>
                  </div>

                  <p className="testimonial-card-three__quote">{item.text}</p>

                  <div className="testimonial-card-three__identity">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="testimonial-card-three__image"
                    />
                    <div className="testimonial-card-three__identity__content">
                      <h4 className="testimonial-card-three__name">{item.name}</h4>
                      <p className="testimonial-card-three__designation">{item.role}</p>
                    </div>
                  </div>
                </div>
                <img
                  src="assets/images/shapes/testimonial-shape-3-1.jpg"
                  alt="shape"
                  className="testimonial-card-three__shape"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsThree;
